import { FilterState, FilterItem } from './index'

export const findItemIndex = (items: FilterItem[], item: Pick<FilterItem, 'id' | 'field'>) => {
  const byId = items.findIndex(x => x.id === item.id)
  if (byId >= 0) {
    return byId
  }
  const byField = items.findIndex(x => x.field === item.field)
  return byField >= 0 ? byField : undefined
}

export const findFilterIndex = (state: FilterState) => (item: Pick<FilterItem, 'id' | 'field'>) => {
  findItemIndex(state.filterItems, item)
}
